<div class="container-fluid p-2 busy-overlay-parent" [ngClass]="isLoading||!appState.isReady?'disabled':''">

    <div *ngIf="isLoading||!appState.isReady" class="font-weight-bold busy-overlay">
        <i class="fa fa-spinner fa-spin"></i>&nbsp;Loading...
    </div>

    <div class="pb-0 d-flex flex-wrap">
        <div class="py-2">
           {{tmpTask.stage}}/{{tmpTask.buildingId}}
        </div>
    </div>

    <div class="container-fluid">
        <div class="row">
            <div class="col-md-6">
                <div class="d-flex flex-row justify-content-between py-2">
                    <div class="font-italic h5 p-0 m-0">
                        Building Info
                    </div>
                </div>
                    <span class="gray font-italic pl-2">Building</span>
                    <table class="table table-striped">
                        <tr>
                            <th class="text-right">Name</th>
                            <td>{{tmpTask.buildingId}}</td>
                        </tr>
                        <tr>
                            <th class="text-right">Address</th>
                            <td>{{building.civicAddress}}</td>
                        </tr>
                    </table>
                    <span class="gray font-italic pl-2">Contact</span>
                    <table class="table table-striped">
                        <tr>
                            <th class="text-right">Name</th>
                            <td>{{building.contactName}}</td>
                        </tr>
                        <tr>
                            <th class="text-right">Phone</th>
                            <td>{{building.contactNumber}}</td>
                        </tr>
                        <tr>
                            <th class="text-right">Email</th>
                            <td>{{building.contactEmail}}</td>
                        </tr>
                    </table>
            </div>
            <div class="col-md-6">
                <div class="d-flex flex-row justify-content-between py-2">
                    <div class="font-italic h5 p-0 m-0">
                        Schedule Details
                    </div>
                    <div *ngIf="scheduleForm.dirty" style="float: right;" class="d-flex flex-row">
                        <button class="btn btn-primary" (click)="onSaveClick(scheduleForm)">Save</button>
                        &nbsp;
                        <button class="btn btn-secondary" (click)="onCancelClick(scheduleForm)">Cancel</button>
                    </div>
                </div>

                <form #scheduleForm="ngForm">
                    <table class="table table-striped">
                        <tr>
                            <th class="text-right">Status</th>
                            <td>{{currentStatus}}</td>
                        </tr>
                        <tr>
                            <th class="text-right">Scheduled Date</th>
                            <td><input id="scheduleDate" name="scheduleDate" type='date' class="form-control" [ngModel]="tmpTask.schedule.scheduledDate|date:'yyyy-MM-dd'" (ngModelChange)="tmpTask.schedule.scheduledDate = $event" #scheduleDate="ngModel" required 
                                [ngClass]="{ 'invalid-input': scheduleDate.invalid && (scheduleDate.dirty || scheduleDate.touched)}"></td>
                        </tr>
                        <tr>
                            <th class="text-right">Assigned to</th>
                            <td>
                                <select id="tester" name="tester" [(ngModel)]="tmpTask.assignments.testUserId">
                                    <option *ngFor="let user of testerUsers" [ngValue]="user._id">{{user.firstName + ' ' + user.lastName}}</option>
                                </select>
                                <!-- {{tmpTask.assignments.testUserId}} -->
                            </td>
                        </tr>
                    </table>
                    <span class="gray font-italic pl-2">Access Procedures/Notes</span>
                    <textarea id="notes" name="notes" [(ngModel)]="tmpTask.schedule.scheduleNotes" rows="5" class="w-100 ml-1" style="resize: none" #notes="ngModel" required 
                    [ngClass]="{ 'invalid-input': scheduleDate.invalid && (scheduleDate.dirty || scheduleDate.touched)}"></textarea>
                </form>

                <div class="d-flex flex-row justify-content-between py-2">
                    <div class="font-italic h5 p-0 m-0">
                        Log
                    </div>
                </div>
                <div class="pt-2">
                    <app-task-schedule-comments #taskScheduleComments [taskDoc]="task"></app-task-schedule-comments>
                </div>
            </div>
        </div>
    </div>
</div>